import oneTimeLiveLessonStartedMutation from '../mutations/OneTimeLiveLessonStarted.gql'

export default function (variables) {
  return {
    mutation: oneTimeLiveLessonStartedMutation,
    variables: variables,
  }
}
